import {RouteConfig} from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import Review from './pages/Review.vue';

export default [
    {
        path: '/:tenantId/review',
        name: 'Review',
        component: Review,
        props: (route) => ({tenantId: route.params.tenantId}),
        meta: {
            permissions: [ PermissionTypeEnum.PlanItemReview ],
            checkLicence: true,
            title: "menu.reviewLong"
        }
    }
] as RouteConfig[];